/**
 * Avatar — a circle of initials on one of the sanctioned avatar gradients (design-spec/01
 * "Avatars"). `aria-hidden`: the person's name is always rendered beside it, so the initials are
 * pure decoration and the white-on-gradient contrast exemption holds (design-spec/01 Accessibility).
 */
import type { AvatarKind } from '@/lib/ledger';

const GRADIENTS: Record<AvatarKind, string> = {
  sage: 'linear-gradient(140deg,#7A9278,#5E7860)',
  coral: 'linear-gradient(140deg,#D9704A,#C25B37)',
  plum: 'linear-gradient(140deg,#8B7BB5,#6A5C92)',
  'deep-sage': 'linear-gradient(140deg,#5E7860,#455A48)',
  muted: 'linear-gradient(140deg,#B0A89A,#8A8172)',
};

interface AvatarProps {
  initials: string;
  kind: AvatarKind;
  /** px diameter — 34 in the ledger row, 28 in the topbar (design-spec/01 sizes). */
  size?: number;
}

export function Avatar({ initials, kind, size = 34 }: AvatarProps) {
  return (
    <span
      aria-hidden="true"
      className="grid flex-none place-items-center rounded-full font-display font-semibold text-white"
      style={{
        width: size,
        height: size,
        background: GRADIENTS[kind],
        fontSize: Math.round(size * 0.37),
      }}
    >
      {initials}
    </span>
  );
}
